export const openExternalLink = (url: string, openInNewTab = false) => {
  if (openInNewTab) {
    window.open(url, '_blank')
  } else {
    window.location.href = url
  }
}
